import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { isNullOrWhiteSpace } from '../../../utilities/string'
import { Dropdown } from '../../Forms/Dropdown'
import { DropdownInputProps } from '../types'
import { useDefaultValue } from '../useDefaultValue'
import { useValidationState } from '../useValidationState'
import { getValidationRules } from '../validation'

export type RHFDropdownProps = {
  input: DropdownInputProps
  readonly?: boolean
  id?: string
}

export const RHFDropdown = ({ input, id }: RHFDropdownProps) => {
  const { control } = useFormContext()

  const validationRules = useMemo(() => getValidationRules(input), [input])

  const validationState = useValidationState(input.slug)

  useDefaultValue({
    name: input.slug,
    value: input.defaultValue,
  })

  return (
    <Controller
      control={control}
      defaultValue={
        input.defaultValue ??
        (isNullOrWhiteSpace(input.placeholder) ? input.options[0] ?? '' : '')
      }
      name={input.slug}
      rules={validationRules}
      render={({ field }) => (
        <Dropdown
          id={id}
          {...input}
          {...field}
          required={!!validationRules?.required}
          validation={validationState}
          variant="button"
        />
      )}
    />
  )
}
